import React, { useEffect, useRef } from "react";
import "./BrandExperience.css";
import emailjs from '@emailjs/browser';

const BrandExperience = () => {
    const bannerRef = useRef(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) bannerRef.current.classList.add("visible");
            },
            { threshold: 0.3 }
        );
        if (bannerRef.current) observer.observe(bannerRef.current);
    }, []);

    return (
        <section className="brandexperience">
            {/* === SECCIÓN 1: Banner con animación === */}
            <p className="subtitle">we make it <span>happen.</span></p>
            <div className="brandexperience-banner" ref={bannerRef}>
                {/* Imagen para PC */}
                <img
                    src="/images/brandexperience/fondo.png"
                    alt="fondo"
                    className="fondo fondo-pc"
                />
                {/* Imagen para Móvil */}
                <img
                    src="/images/brandexperience/fondo-movil.webp"
                    alt="fondo móvil"
                    className="fondo fondo-movil"
                />
                {/* <img src="/images/brandexperience/flor_alta.png" alt="flor1" className="flor1" />
                <img src="/images/brandexperience/flor_baja.png" alt="flor2" className="flor2" /> */}
                {/* <div className="brandexperience-banner-texto">
                    <h3>Impresión en <br></br><span className="bold">BRAND EXPERIENCE</span></h3>
                    <img src="/images/logo/MotiPuntos.svg" style={{ height: '0.7rem' }}></img>
                    <p>Innovación en cada solución</p>
                </div> */}
            </div>

            {/* === SECCIÓN 2: Texto + Imagen edificio === */}
            <div className="brandexperience-info">
                <p className="brandexperience-subtitle">we make it <span>happen.</span></p>

                <div className="brandexperience-info-contenido">
                    <div className="brandexperience-info-texto">
                        <div className="brandexperience-tag">
                            <img src="/images/brandexperience/tagicon.svg" style={{ height: '1rem' }}></img> Brand Experience
                        </div>
                        <h2>
                            Escaparates que jamás se escaparán <br></br> de tu mente.

                        </h2>
                        <p>
                            Transformamos cada espacio en una extensión de tu marca. Con  <b>escaparates impactantes, </b> nos aseguramos de crear experiencias que conecten emocionalmente con tus clientes.
                        </p>
                        <p className="brandexperience-cta">
                            En Moti Digital lo hacemos posible, <a href="#cotiza">solicita tu cotización:</a>
                        </p>
                        <div className="brandexperience-input-wrapper">
                            <form
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    const form = e.target;
                                    const button = form.querySelector("button");
                                    const input = form.querySelector("input");

                                    button.disabled = true;
                                    const originalText = button.textContent;
                                    button.textContent = "Enviando...";

                                    try {
                                        const serviceID = "service_lxg5sht";
                                        const templateID = "template_epehkcc";
                                        const publicKey = "4f0iRLKGvmXsd0ASA";

                                        const params = {
                                            from_name: input.value,
                                            message: `Me interesan sus productos de Brand experience. Me pueden contactar al correo ${input.value}, me estoy contactando desde motidigital.com `,
                                        };

                                        console.log("📤 Enviando con EmailJS...");
                                        console.log({ serviceID, templateID, publicKey, params });

                                        const res = await emailjs.send(serviceID, templateID, params, publicKey);
                                        console.log("✅ Respuesta EmailJS:", res);

                                        if (res.status === 200) {
                                            button.textContent = "Enviado ✔";
                                            input.value = "";
                                            setTimeout(() => {
                                                button.textContent = originalText;
                                                button.disabled = false;
                                            }, 3000);
                                        } else {
                                            throw new Error("Error en el envío");
                                        }
                                    } catch (error) {
                                        console.error("❌ Error al enviar con EmailJS:", error);

                                        button.textContent = "Error ✖";
                                        setTimeout(() => {
                                            button.textContent = originalText;
                                            button.disabled = false;
                                        }, 2500);
                                    }
                                }}
                            >
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Tu correo electrónico"
                                    required
                                />
                                <button type="submit">Empecemos</button>
                            </form>
                        </div>
                    </div>

                    <div className="brandexperience-info-imagen">
                        <img src="/images/brandexperience/fondo-info.png" alt="Brand experience en edificio" />
                    </div>
                </div>
            </div>

            <div className="brandexperience-final">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="brandexperience-dots" />
                <h2>
                    ¿Listo para hacer crecer <br />
                    <span>tu empresa?</span>
                </h2>

                {/* Doble marquee - VERSIÓN SIMPLE */}
                <div className="brandexperience-marquees">
                    <div className="brandexperience-marquee brandexperience-line1">
                        <span>
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                        </span>
                        <span>
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                            CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE · CREACIÓN DE ·
                        </span>
                    </div>

                    <div className="brandexperience-marquee brandexperience-line2">
                        <span>
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                        </span>
                        <span>
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                            PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS · PROYECTOS ÚNICOS ·
                        </span>
                    </div>
                </div>

                {/* Slider semicircular */}
                <div className="brandexperience-slider">
                    <div className="brandexperience-slider-track">
                        <img src="/images/brandexperience/slider/1.png" alt="img1" />
                        <img src="/images/brandexperience/slider/2.png" alt="img2" />
                        <img src="/images/brandexperience/slider/3.png" alt="img3" />
                        <img src="/images/brandexperience/slider/4.png" alt="img4" />
                        <img src="/images/brandexperience/slider/5.png" alt="img5" />
                    </div>
                </div>
            </div>

            {/* === SECCIÓN 3: Opción estratégica === */}
            <div className="brandexperience-opcion">
                <img src="/images/logo/Moti Logo.svg" alt="decorativo" className="brandexperience-opcion-icon" />

                <div className="brandexperience-opcion-card">
                    <div className="brandexperience-opcion-left">
                        <h2>Servicios que <br></br>potencian tu Brand Experience</h2>
                        <p>Innovación y calidad<br></br>en cada material</p>
                        <button className="brandexperience-btn-cotizar">Cotizar ahora</button>
                    </div>

                    <div className="brandexperience-opcion-right">
                        <div className="brandexperience-opcion-item">
                            <div className="brandexperience-icon" style={{ backgroundColor: "#f7c19a" }}>
                                <img src="/images/brandexperience/vector.svg" alt="Variedad" />
                            </div>
                            <div>
                                <h4>Diseño gráfico:</h4>
                                <p>Diseño creativo que refleja la esencia de tu marca.</p>
                            </div>
                        </div>

                        <div className="brandexperience-opcion-item">
                            <div className="brandexperience-icon" style={{ backgroundColor: "#c9e7e4" }}>
                                <img src="/images/brandexperience/preprensa.svg" alt="Personalización" />
                            </div>
                            <div>
                                <h4>Preprensa:</h4>
                                <p>Preparación técnica para garantizar resultados impecables.</p>
                            </div>
                        </div>

                        <div className="brandexperience-opcion-item">
                            <div className="brandexperience-icon" style={{ backgroundColor: "#e8c7d4" }}>
                                <img src="/images/brandexperience/diseno.svg" alt="Sostenibilidad" />
                            </div>
                            <div>
                                <h4>Diseño industrial:</h4>
                                <p>Creación de estructuras y elementos innovadores para experiencias únicas.</p>
                            </div>
                        </div>
                        <div className="brandexperience-opcion-item">
                            <div className="brandexperience-icon" style={{ backgroundColor: "#ece4dd" }}>
                                <img src="/images/brandexperience/taller.svg" alt="Sostenibilidad" />
                            </div>
                            <div>
                                <h4>Taller integral:</h4>
                                <p>Equipado con pintura, soldadura, carpintería, laminado, electricidad, y más.</p>
                            </div>
                        </div>
                        <div className="brandexperience-opcion-item">
                            <div className="brandexperience-icon" style={{ backgroundColor: "#f97180" }}>
                                <img src="/images/brandexperience/instalacion.svg" alt="Sostenibilidad" />
                            </div>
                            <div>
                                <h4>Servicio de instalación:</h4>
                                <p>Montaje profesional para asegurar un impacto visual inmediato.</p>
                            </div>
                        </div>
                        <div className="brandexperience-opcion-item">
                            <div className="brandexperience-icon" style={{ backgroundColor: "#f3b889" }}>
                                <img src="/images/brandexperience/logistica.svg" alt="Sostenibilidad" />
                            </div>
                            <div>
                                <h4>Logística propia:</h4>
                                <p>Entregas eficientes y seguras, desde nuestra planta hasta tu punto de activación.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="brandexperience-faq">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="brandexperience-dots" />
                <h2>Preguntas frecuentes</h2>
                <div className="brandexperience-faq-contenedor">
                    {/* Lado izquierdo - Acordeón */}
                    <div className="brandexperience-faq-lista">
                        <details open>
                            <summary>¿Tienen taller?</summary>
                            <p>
                                Sí, contamos con un taller especializado para la fabricación y producción de proyectos personalizados,
                                incluyendo carpintería, laminado, pintura, herrería y electricidad. Nuestras instalaciones cuentan con
                                tecnología de punta y personal calificado para garantizar la más alta calidad en cada proyecto.
                            </p>
                        </details>

                        <details>
                            <summary>¿Ofrecen servicios de instalación?</summary>
                            <p>
                                Absolutamente. Ofrecemos servicios completos de instalación en todo el territorio nacional. Nuestro equipo
                                de instaladores profesionales se encarga de montar y colocar cada elemento, asegurando que tu proyecto
                                quede perfectamente instalado y funcional según tus especificaciones.
                            </p>
                        </details>

                        <details>
                            <summary>¿Ofrecen servicios de diseño gráfico e industrial?</summary>
                            <p>
                                Sí, contamos con equipos especializados en diseño gráfico e industrial. Nuestros diseñadores trabajan
                                contigo para crear conceptos innovadores que se alineen con tu marca, desde el diseño inicial hasta
                                la producción final, asegurando coherencia visual y funcionalidad en cada proyecto.
                            </p>
                        </details>

                        <details>
                            <summary>¿Qué materiales y tecnologías utilizan?</summary>
                            <p>
                                Utilizamos una amplia gama de materiales de alta calidad como acrílicos, MDF, aluminio,
                                Contamos con tecnología de impresión UV, corte láser,
                                fabricación digital para ofrecer soluciones innovadoras y duraderas.
                            </p>
                        </details>

                        <details>
                            <summary>¿Pueden crear experiencias personalizadas para mi marca?</summary>
                            <p>
                                ¡Definitivamente! Especializamos en crear experiencias de marca completamente personalizadas.
                                Desarrollamos conceptos únicos que reflejan la esencia de tu marca, integrando elementos
                                interactivos, iluminación especializada y diseño espacial para crear experiencias memorables
                                que conecten emocionalmente con tu audiencia.
                            </p>
                        </details>
                    </div>

                    {/* Lado derecho - Contacto */}
                    <div className="brandexperience-faq-contacto">
                        <h3>¿Tienes más dudas?</h3>
                        <p>No dudes en contactarnos para más información.</p>

                        <div className="brandexperience-contacto-email">
                            <div className="brandexperience-email-box">
                                <img src="/images/brandexperience/mail.svg" alt="email" />
                                <span>COTIZACIONES@MOTIDIGITAL.COM</span>
                                <button>Agendar una llamada</button>
                            </div>
                            <button className="brandexperience-btn-whatsapp"> Cotiza tu proyecto</button>
                        </div>

                        <div className="brandexperience-faq-img">
                            <img src="/images/granformato/faq-banner.png" alt="FAQ" />
                        </div>
                    </div>
                </div>
            </div>

        </section>

    );
};

export default BrandExperience;